var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWbK(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.68 35.14",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: 0
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m3.05 2.617h19.358v38.632h-19.358z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m22.492 3.814h18.647v37.85h-18.647z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0)",
    transform: "translate(-5.082-5.234)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.5 11.63v-5.63",
    stroke: "#000",
    strokeLinejoin: "miter",
    id: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 8h5",
    stroke: "#000",
    strokeLinejoin: "miter",
    id: 3
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.5 25c0 0 4.5-7.5 3-10.5 0 0-1-2.5-3-2.5-2 0-3 2.5-3 2.5-1.5 3 3 10.5 3 10.5",
    strokeLinejoin: "miter",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.5 37c5.5 3.5 15.5 3.5 21 0v-7c0 0 9-4.5 6-10.5-4-6.5-13.5-3.5-16 4v3.5-3.5c-3.5-7.5-13-10.5-16-4-3 6 5 10 5 10v7.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m11.5 30c5.5-3 15.5-3 21 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.5 33.5c5.5-3 15.5-3 21 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.5 37c5.5-3 15.5-3 21 0"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.166-5.234)",
    clipPath: "url(#1)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.5 25c0 0 4.5-7.5 3-10.5 0 0-1-2.5-3-2.5-2 0-3 2.5-3 2.5-1.5 3 3 10.5 3 10.5",
    strokeLinejoin: "miter",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.5 37c5.5 3.5 15.5 3.5 21 0v-7c0 0 9-4.5 6-10.5-4-6.5-13.5-3.5-16 4v3.5-3.5c-3.5-7.5-13-10.5-16-4-3 6 5 10 5 10v7.5z",
    stroke: "#000"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32 29.5c0 0 8.5-4 6.03-9.65-3.88-5.85-13.03-1.85-15.53 4.65l.01 2.1-.01-2.1c-2.5-6.5-12.594-10.5-15.503-4.65-2.497 5.65 4.853 9 4.853 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.5 30c5.5-3 15.5-3 21 0m-21 3.5c5.5-3 15.5-3 21 0m-21 3.5c5.5-3 15.5-3 21 0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbK);
export default __webpack_public_path__ + "static/media/wbK.c1ff0c86f1e9342931d248eaabafc928.svg";
export { ForwardRef as ReactComponent };